export default "__VITE_ASSET__D3dInttQ__"